module.exports = __webpack_public_path__ + "img/sbp_det.cec42631.png";